export const LinkedInLogo = () => {
  return (
    <svg
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00002 12.5H2.66669V28.5H8.00002V12.5Z"
        stroke="#4F29B7"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.3333 11.1665C23.455 11.1665 25.4899 12.0094 26.9902 13.5096C28.4905 15.0099 29.3333 17.0448 29.3333 19.1665V28.4998H24V19.1665C24 18.4593 23.719 17.781 23.2189 17.2809C22.7188 16.7808 22.0406 16.4998 21.3333 16.4998C20.6261 16.4998 19.9478 16.7808 19.4477 17.2809C18.9476 17.781 18.6666 18.4593 18.6666 19.1665V28.4998H13.3333V19.1665C13.3333 17.0448 14.1762 15.0099 15.6765 13.5096C17.1768 12.0094 19.2116 11.1665 21.3333 11.1665V11.1665Z"
        stroke="#4F29B7"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.33335 8.49984C6.80611 8.49984 8.00002 7.30593 8.00002 5.83317C8.00002 4.36041 6.80611 3.1665 5.33335 3.1665C3.86059 3.1665 2.66669 4.36041 2.66669 5.83317C2.66669 7.30593 3.86059 8.49984 5.33335 8.49984Z"
        stroke="#4F29B7"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const TwitterLogo = () => {
  return (
    <svg
      width="26"
      height="27"
      viewBox="0 0 26 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.9977 11.5092L24.3791 0.5H22.156L14.0101 10.0592L7.50402 0.5H0L9.8385 14.9551L0 26.5H2.22322L10.8255 16.4052L17.6964 26.5H25.2004L14.9977 11.5092ZM11.9527 15.0825L10.9558 13.6431L3.02428 2.18958H6.43903L12.8399 11.4329L13.8367 12.8723L22.1571 24.8873H18.7423L11.9527 15.0825Z"
        fill="#4F29B7"
      />
    </svg>
  );
};

export const InstagramLogo = () => {
  return (
    <svg
      width="28"
      height="27"
      viewBox="0 0 28 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.12 4.77984C20.8035 4.77984 20.4942 4.87368 20.231 5.04949C19.9679 5.2253 19.7629 5.47518 19.6418 5.76754C19.5207 6.05991 19.489 6.38161 19.5507 6.69198C19.6124 7.00235 19.7648 7.28744 19.9886 7.51121C20.2124 7.73497 20.4974 7.88736 20.8078 7.94909C21.1182 8.01083 21.4399 7.97914 21.7323 7.85804C22.0246 7.73694 22.2745 7.53187 22.4503 7.26875C22.6261 7.00563 22.72 6.69629 22.72 6.37984C22.72 5.95549 22.5514 5.54852 22.2513 5.24847C21.9513 4.94841 21.5443 4.77984 21.12 4.77984V4.77984ZM27.2533 8.0065C27.2274 6.90024 27.0202 5.80571 26.64 4.7665C26.3009 3.87735 25.7733 3.07221 25.0933 2.4065C24.4331 1.72307 23.626 1.19874 22.7333 0.873171C21.6968 0.481385 20.6011 0.269451 19.4933 0.246504C18.08 0.166504 17.6266 0.166504 14 0.166504C10.3733 0.166504 9.91996 0.166504 8.50663 0.246504C7.39883 0.269451 6.30308 0.481385 5.26663 0.873171C4.37553 1.20204 3.5692 1.72592 2.90663 2.4065C2.22319 3.06674 1.69886 3.87376 1.37329 4.7665C0.981507 5.80296 0.769573 6.89871 0.746626 8.0065C0.666626 9.41984 0.666626 9.87317 0.666626 13.4998C0.666626 17.1265 0.666626 17.5798 0.746626 18.9932C0.769573 20.101 0.981507 21.1967 1.37329 22.2332C1.69886 23.1259 2.22319 23.9329 2.90663 24.5932C3.5692 25.2738 4.37553 25.7976 5.26663 26.1265C6.30308 26.5183 7.39883 26.7302 8.50663 26.7532C9.91996 26.8332 10.3733 26.8332 14 26.8332C17.6266 26.8332 18.08 26.8332 19.4933 26.7532C20.6011 26.7302 21.6968 26.5183 22.7333 26.1265C23.626 25.8009 24.4331 25.2766 25.0933 24.5932C25.7763 23.9299 26.3044 23.1241 26.64 22.2332C27.0202 21.194 27.2274 20.0994 27.2533 18.9932C27.2533 17.5798 27.3333 17.1265 27.3333 13.4998C27.3333 9.87317 27.3333 9.41984 27.2533 8.0065V8.0065ZM24.8533 18.8332C24.8436 19.6795 24.6903 20.5181 24.4 21.3132C24.1871 21.8934 23.8451 22.4177 23.4 22.8465C22.9675 23.2872 22.4443 23.6284 21.8666 23.8465C21.0716 24.1368 20.233 24.2901 19.3866 24.2998C18.0533 24.3665 17.56 24.3798 14.0533 24.3798C10.5466 24.3798 10.0533 24.3798 8.71996 24.2998C7.84115 24.3163 6.96609 24.181 6.13329 23.8998C5.581 23.6706 5.08177 23.3302 4.66663 22.8998C4.22408 22.4715 3.88642 21.9468 3.67996 21.3665C3.35443 20.56 3.17388 19.7024 3.14663 18.8332C3.14663 17.4998 3.06663 17.0065 3.06663 13.4998C3.06663 9.99317 3.06663 9.49984 3.14663 8.1665C3.1526 7.30124 3.31056 6.44376 3.61329 5.63317C3.84802 5.07039 4.20831 4.56872 4.66663 4.1665C5.07171 3.70806 5.57234 3.34397 6.13329 3.09984C6.94603 2.80656 7.80262 2.65328 8.66663 2.6465C9.99996 2.6465 10.4933 2.5665 14 2.5665C17.5066 2.5665 18 2.5665 19.3333 2.6465C20.1797 2.65621 21.0182 2.8095 21.8133 3.09984C22.4192 3.32471 22.963 3.6903 23.4 4.1665C23.8369 4.57608 24.1783 5.07681 24.4 5.63317C24.6963 6.44508 24.8497 7.30221 24.8533 8.1665C24.92 9.49984 24.9333 9.99317 24.9333 13.4998C24.9333 17.0065 24.92 17.4998 24.8533 18.8332ZM14 6.65984C12.6477 6.66247 11.3266 7.06587 10.2035 7.81906C9.08042 8.57225 8.2058 9.64143 7.69014 10.8915C7.17448 12.1416 7.04092 13.5165 7.30635 14.8424C7.57178 16.1684 8.22427 17.3859 9.18139 18.3411C10.1385 19.2964 11.3573 19.9465 12.6838 20.2094C14.0102 20.4722 15.3848 20.336 16.6339 19.8179C17.883 19.2998 18.9505 18.4231 19.7015 17.2985C20.4525 16.174 20.8533 14.8521 20.8533 13.4998C20.8551 12.6 20.6789 11.7086 20.3349 10.8771C19.991 10.0456 19.486 9.29025 18.8491 8.65457C18.2122 8.01889 17.4559 7.51541 16.6237 7.17308C15.7915 6.83074 14.8998 6.65632 14 6.65984V6.65984ZM14 17.9398C13.1218 17.9398 12.2634 17.6794 11.5332 17.1916C10.8031 16.7037 10.234 16.0103 9.89793 15.199C9.56188 14.3876 9.47395 13.4949 9.64527 12.6336C9.81659 11.7724 10.2395 10.9812 10.8604 10.3603C11.4814 9.73934 12.2725 9.31647 13.1338 9.14515C13.995 8.97383 14.8878 9.06176 15.6991 9.39781C16.5104 9.73387 17.2038 10.303 17.6917 11.0331C18.1796 11.7633 18.44 12.6217 18.44 13.4998C18.44 14.0829 18.3251 14.6603 18.102 15.199C17.8789 15.7376 17.5518 16.2271 17.1395 16.6394C16.7272 17.0517 16.2378 17.3787 15.6991 17.6019C15.1604 17.825 14.583 17.9398 14 17.9398V17.9398Z"
        fill="#4F29B7"
      />
    </svg>
  );
};

export const EmailLogo = () => {
  return (
    <svg
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.33329 5.8335H26.6666C28.1333 5.8335 29.3333 7.0335 29.3333 8.50016V24.5002C29.3333 25.9668 28.1333 27.1668 26.6666 27.1668H5.33329C3.86663 27.1668 2.66663 25.9668 2.66663 24.5002V8.50016C2.66663 7.0335 3.86663 5.8335 5.33329 5.8335Z"
        stroke="#4F29B7"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M29.3333 8.5L16 17.8333L2.66663 8.5"
        stroke="#4F29B7"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const CopyLinkLogo = () => {
  return (
    <svg
      width="32"
      height="28"
      viewBox="0 0 32 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3334 17.8334C13.906 18.599 14.6365 19.2324 15.4754 19.6907C16.3144 20.149 17.2421 20.4216 18.1956 20.4899C19.1491 20.5582 20.1062 20.4206 21.0018 20.0865C21.8975 19.7524 22.7109 19.2295 23.3867 18.5534L27.3867 14.5534C28.6011 13.2961 29.2731 11.6121 29.2579 9.86411C29.2427 8.11613 28.5416 6.44405 27.3055 5.20799C26.0694 3.97194 24.3974 3.27081 22.6494 3.25562C20.9014 3.24043 19.2174 3.9124 17.96 5.12678L15.6667 7.40678"
        stroke="#4F29B7"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.6667 15.1666C18.0941 14.4011 17.3635 13.7677 16.5246 13.3094C15.6857 12.851 14.758 12.5785 13.8045 12.5102C12.851 12.4419 11.8939 12.5795 10.9982 12.9136C10.1025 13.2477 9.2892 13.7705 8.61336 14.4466L4.61336 18.4466C3.39897 19.704 2.72701 21.388 2.7422 23.136C2.75738 24.884 3.45851 26.556 4.69457 27.7921C5.93062 29.0282 7.6027 29.7293 9.35068 29.7445C11.0987 29.7597 12.7827 29.0877 14.04 27.8733L16.32 25.5933"
        stroke="#4F29B7"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
